import { Entity } from '../../../../entities/entity';
import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { MergeDataset } from '../../decorators/decorators/merge.dataset';
import { MergeSource } from '../../decorators/decorators/merge.source';
import { ActivityMergeData, ActivityMergeSchema, AttachmentMergeData, AttachmentMergeSchema } from '../data/activity.merge.data';
import { BasicSiteMergeData, BasicSiteMergeSchema } from '../data/basic.site.merge.data';
import { CompanyMergeData, CompanyMergeSchema } from '../data/company.merge.data';
import { InvoiceAccountMergeData, InvoiceAccountMergeSchema } from '../data/invoice.account.merge.data';
import { InvoiceActivitiesMergeData, InvoiceActivitiesMergeDataSchema, InvoiceAttachmentsMergeData, InvoiceAttachmentsMergeDataSchema } from '../data/invoice.attachments.merge.data';
import { InvoiceMergeData, InvoiceMergeSchema } from '../data/invoice.merge.data';

@MergeDataset({
    entity: ActivityEntityName.Invoice,
    dependsOn: [
        ActivityEntityName.Job
    ]
})
export class InvoiceMergeDataset {

    @MergeSource({
        schema: InvoiceMergeSchema
    })
    invoice: InvoiceMergeData;

    @MergeSource({
        schema: CompanyMergeSchema
    })
    invoiceCompany: CompanyMergeData;

    @MergeSource({
        schema: InvoiceAccountMergeSchema
    })
    invoiceAccount: InvoiceAccountMergeData;

    @MergeSource({
        schema: BasicSiteMergeSchema
    })
    invoiceAccountSite: BasicSiteMergeData;

    @MergeSource({
        schema: BasicSiteMergeSchema
    })
    invoiceJobSite: BasicSiteMergeData;

    @MergeSource({
        schema: ActivityMergeSchema,
        displayName: "Activities (Deprecated)",
        ignoreFields: ['attachments']
    })
    activities: ActivityMergeData[];

    @MergeSource({
        schema: AttachmentMergeSchema,
        displayName: "Media Attachments (Deprecated)",

    })
    mediaAttachments: AttachmentMergeData[];

    @MergeSource({
        schema: AttachmentMergeSchema,
        displayName: "File Attachments (Deprecated)"
    })
    fileAttachments: AttachmentMergeData[];

    @MergeSource({
        schema: InvoiceActivitiesMergeDataSchema,
        ignoreCustomFields: true,
    })
    invoiceActivities: InvoiceActivitiesMergeData;

    @MergeSource({
        schema: InvoiceAttachmentsMergeDataSchema,
        ignoreCustomFields: true,
    })
    invoiceAttachment: InvoiceAttachmentsMergeData;

    public theme: Entity;
}


